module.exports = __webpack_public_path__ + "img/微信图片_20240708223032-恢复的-恢复的.88b6b904.jpg";